import React, { Component } from "react";
import { connect } from "react-redux";
import { alertConstants } from "../../constants";

class AlertArea extends Component {
  render() {
    const spinner = require("../../images/spinner-purple.svg").default;

    const { alert } = this.props;
    let renderVal;
    //let isAlert = false;
    //let isPrompt = false;
    let isSpinner = false;
    if (alert?.type) {
      renderVal = alert.message;
      switch (alert.type) {
        case alertConstants.SPINNER: {
          //isAlert = true;
          isSpinner = true;
          break;
        }
        case alertConstants.ERROR: {
          //isAlert = true;
          if (alert.message instanceof TypeError) {
            renderVal = alert.message.message;
          }
          break;
        }
        case alertConstants.PROMPT: {
          //isPrompt = true;
          renderVal = alert.message;
          break;
        }
      }
    }

    return (
      <div className="promptArea">
        {!isSpinner && (
          <div>
            {renderVal} <br />
            <br />
          </div>
        )}
        {isSpinner && <img src={spinner} alt="spinner" />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  return { alert };
}

const connectedAlertArea = connect(mapStateToProps)(AlertArea);
export { connectedAlertArea as AlertArea };
